@if (message.length > 0) {
  <div
    [ngClass]="{ 'error-active': message.length > 0 }"
    class="form-control-validation-error d-flex"
    role="alert"
    aria-live="polite"
  >
    <svg role="img" viewBox="0 0 24 24" class="me-1 flex-shrink-0" aria-hidden="true">
      <title>{{ ('status_error' | translate) + ':' }}</title>
      <use xlink:href="#exclamation-square"></use>
    </svg>
    <p [id]="errorMessageId || 'error-message'">{{ message }}</p>
  </div>
}
